'use client';

import React from 'react';
import { PosSelectCustomer } from '@castlery/modules-user-components';
import { Box } from '@castlery/fortress';
import { selectedCurrentCustomer } from '@castlery/modules-user-domain';
import { useAppSelector } from '@castlery/shared-redux-store';
import { PosOnlineCart } from '@castlery/modules-order-components';
import { CreateAUser } from '@castlery/modules-user-components';
/* eslint-disable-next-line */
export interface PosCustomerHeaderProps {}

export function PosCustomerHeader(props: PosCustomerHeaderProps) {
  const customer = useAppSelector(selectedCurrentCustomer);
  return (
    <Box
      sx={{
        height: 65,
        display: 'grid',
        gridTemplateColumns: 'auto 40px',
        alignItems: 'center',
        background: (theme) => theme.palette.brand.wheat[50],
        paddingX: 2,
        paddingY: 1,
        gap: 2,
      }}
    >
      <PosSelectCustomer />
      {customer ? <PosOnlineCart /> : <CreateAUser />}
    </Box>
  );
}
